(function () {
  if (window.eltaggPremiumActionsReady) return;
  window.eltaggPremiumActionsReady = true;

  function showToast(message) {
    let toast = document.querySelector('.eltagg-premium-toast');

    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'eltagg-premium-toast';
      document.body.appendChild(toast);
    }

    toast.textContent = message;
    toast.classList.add('is-visible');

    clearTimeout(window.eltaggPremiumToastTimer);
    window.eltaggPremiumToastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2000);
  }

  async function updateCartBubble() {
    const cart = await fetch('/cart.js').then(function (res) {
      return res.json();
    });

    const bubbleWrap = document.getElementById('cart-icon-bubble');
    if (!bubbleWrap) return;

    let bubble = bubbleWrap.querySelector('.cart-count-bubble');

    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      bubble.innerHTML = '<span aria-hidden="true"></span>';
      bubbleWrap.appendChild(bubble);
    }

    const count = bubble.querySelector('span[aria-hidden="true"]');
    if (count) count.textContent = cart.item_count;
  }

  document.addEventListener('click', async function (event) {
    const colorBtn = event.target.closest('[data-eltagg-color]');
    const cartBtn = event.target.closest('[data-eltagg-premium-cart]');

    if (!colorBtn && !cartBtn) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (colorBtn) {
      const card = colorBtn.closest('.eltagg-premium-card');
      const slider = card ? card.querySelector('[data-card-slider]') : null;
      const targetId = colorBtn.dataset.variantImageId;

      if (!card || !slider || !targetId) return;

      const images = slider.querySelectorAll('.eltagg-premium-card__image');
      let index = 0;

      images.forEach(function (img, i) {
        if (img.dataset.variantImageId === targetId) index = i;
      });

      card.querySelectorAll('[data-eltagg-color]').forEach(function (btn) {
        btn.classList.remove('is-active');
      });

      colorBtn.classList.add('is-active');

      slider.scrollTo({
        left: slider.clientWidth * index,
        behavior: 'smooth'
      });

      const cardCartBtn = card.querySelector('[data-eltagg-premium-cart]');
      if (cardCartBtn && colorBtn.dataset.variantId) {
        cardCartBtn.dataset.variantId = colorBtn.dataset.variantId;
      }

      return;
    }

    if (cartBtn) {
      const variantId = cartBtn.dataset.variantId;
      if (!variantId || cartBtn.disabled) return;

      cartBtn.disabled = true;

      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: Number(variantId),
            quantity: 1
          })
        });

        await updateCartBubble();
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

        showToast('تم الإضافة');
      } catch (error) {
        showToast('حصلت مشكلة');
        console.error(error);
      } finally {
        cartBtn.disabled = false;
      }
    }
  }, true);
})();